import {Component, Input, OnInit} from '@angular/core';
import {Bit} from './bit';

@Component({
  selector: 'app-bit',
  templateUrl: './bit.component.html',
  styleUrls: ['./bit.component.css']
})
export class BitComponent implements OnInit {

  @Input() bit: Bit;
  @Input() size = 10;
  @Input() index = 0;
  @Input() scheme = 0;

  constructor() { }

  ngOnInit(): void {
  }

  get style(): any {
    const headColors = [ '#44876f', '#534daa', '#aa4c64', '#875f33', '#5aaa85'];
    const bgColors = [ '#70ffd3', '#7e1880', '#ffbab9', '#986e3e'];
    return {
      top: `${this.bit.y * this.size}px`,
      left: `${this.bit.x * this.size}px`,
      width: `${this.size - 2}px`,
      height: `${this.size - 2}px`,
      'background-color': this.index
        ? bgColors[this.scheme % bgColors.length]
        : headColors[this.scheme % headColors.length]
    };
  }

  get bitClass(): string {
    return `bit-${this.bit.type}`;
  }
}
